import { Button } from "@/components/ui/button";

export const FinalCTA = ({ onOpenForm }) => (
  <section className="py-24 md:py-32 bg-white" data-testid="final-cta-section">
    <div className="container-custom text-center">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#1F2937] mb-4" style={{ fontFamily: "Manrope" }}>
        Ready to Sell Your Test Strips?
      </h2>
      <p className="text-lg text-[#4B5563] max-w-xl mx-auto mb-8">
        Get cash for your unused diabetic test strips today. It only takes a minute to get started.
      </p>
      <Button
        onClick={onOpenForm}
        className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-10 py-6 text-lg font-semibold shadow-lg transition-all hover:-translate-y-0.5"
        data-testid="cta-sell-btn"
      >
        Get Your Free Offer
      </Button>
    </div>
  </section>
);
